import React from 'react'

import { ITeamFormProps, TeamForm } from '../form/TeamForm'

export const NewTeam: React.FC<Omit<ITeamFormProps, 'isCreating'>> = props => <TeamForm {...props} isCreating />
